<template>
    <div>
        <b-row>
          <b-col>
            <b-img class="thumbnail" :src="url" @click="isModalOpen=true" fluid :alt="record.title"></b-img>
              <b-button
                v-if="getUserAccount.id == record.accountId"
                size="sm"
                variant="link"
                class="mr-1"
                @click="isDeleteModalOpen=true"
              >
                <img
                  src="../../../../assets/images/delete_icon.svg"
                  style="width: 20px; height: 20px"
                />
              </b-button>
          </b-col>
        </b-row>
        <b-modal
        id="modalInfo"
        v-model="isModalOpen"
        size="xl"
        :title="record.title"
        >
            <b-img class="full-image" :src="url" fluid :alt="record.title"></b-img>
            <div>
                    {{ record.account }}
                    -
                    ({{ record.date }})
            </div>

            <div slot="modal-footer" class="w-100" style="text-align: center">
            <b-row class="d-flex justify-content-center">
              <b-col cols="2">
                  <b-btn @click="downloadImage()">
                  {{ $t("label_download_button") }}
                  </b-btn>
              </b-col>   
            </b-row>
          </div>
        </b-modal>
        <delete-record-modal v-if="isDeleteModalOpen" :showModal.sync="isDeleteModalOpen" :id="record.id" @reload="$emit('reload')"/>
    </div>
</template>

<script>
import { axiosCall } from "../../../../utils/axiosCall";
import { mapGetters } from "vuex";
import DeleteRecordModal from "./DeleteRecordModal"

export default {
  name: "ImageThumbnail",
  components: {DeleteRecordModal},
  props: {
    record: {
      type: Object,
      default: {},
    }
  },
  data() {
    return {
        url: '',
        isModalOpen: false,
        isDeleteModalOpen: false
    }
  },
  computed: {
    ...mapGetters(["getUserAccount"]),
  },
  mounted: async function(){
    await axiosCall({ url: "Records/downloadRecord/" + this.record.id + "/" + this.record.name, method: "GET"
      }).then((response) =>{
        this.url = response.data
        });
  },
  methods:{
    downloadImage(){
        const link = document.createElement("a");
        link.setAttribute("style", "display: none");
        link.href = this.url;
        link.download = this.record.name;
        link.target = "_blank";   
        link.click();
        link.remove();

        this.isModalOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>

.full-image {
    max-width: 1000px !important;
}

.thumbnail { 
    max-width: 250px !important;
    &:hover {
        opacity: 0.5 !important;
        cursor: pointer;
    }
}

</style>